module.exports = __webpack_public_path__ + "img/sac.b7336dfd.jpg";